// 曜日選択コンポーネント（日月火水木金土）
interface Props {
  value: number[];
  onChange: (next: number[]) => void;
}

const LABELS = ['日', '月', '火', '水', '木', '金', '土'];

export default function DowPicker({ value, onChange }: Props) {
  const toggle = (dow: number) => {
    if (value.includes(dow)) {
      onChange(value.filter((d) => d !== dow));
    } else {
      onChange([...value, dow].sort());
    }
  };
  return (
    <div className="dow-picker">
      {LABELS.map((label, i) => (
        <button
          key={i}
          type="button"
          className={value.includes(i) ? 'selected' : ''}
          onClick={() => toggle(i)}
          title={label}
        >
          {label}
        </button>
      ))}
      <span className="muted" style={{ marginLeft: 8, fontSize: '0.8rem' }}>
        {value.length === 0 ? '（毎日）' : ''}
      </span>
    </div>
  );
}
